
export interface PollOption {
  /**
   * @minLength 1
   * @maxLength 50
   */
  text: string;
  readonly votes?: number;
}
